import { render, staticRenderFns } from "./ImageMenu.vue?vue&type=template&id=2d83c879&scoped=true&"
import script from "./ImageMenu.vue?vue&type=script&lang=js&"
export * from "./ImageMenu.vue?vue&type=script&lang=js&"
import style0 from "./ImageMenu.vue?vue&type=style&index=0&id=2d83c879&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83c879",
  null
  
)

export default component.exports